import {getCurrentYear} from '../../utils/commons'
import BestTechGearPicksLogo from './logo'
import {bestTechGearPicksStylesUK} from './styles'

const baseConfig = {
  domainName: 'besttechgearpicks' as const,
  domainType: 'picks' as const,
  camelCaseUrl: 'BestTechGearPicks.co.uk',
  siteName: 'Best Tech Gear Picks',
  favicon: '/favicons/besttechgearpicks.png',
}

const localeConfigs = {
  uk: {
    measurementId: 'G-PVHK3D6HPB',
    logo: <BestTechGearPicksLogo locale="uk" className="size-10 shrink-0 tablet:size-8" />,
    title: (category: string, _count: string) =>
      `${category} Worth Buying in ${getCurrentYear()} — Our Top Picks | BestTechGearPicks.co.uk`,
    description: (_category?: string, _count?: string) =>
      `BestTechGearPicks.co.uk evaluates top electronics & tech products products using in-depth analysis and verified user feedback. Discover recommended options you'll value this year.`,
    styles: bestTechGearPicksStylesUK,
  },
}

export const createConfig = (locale: string = 'uk') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.uk
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
